import React from 'react';
import { Box, useBreakpoint } from '@landr/maestro';
import { Styled } from './PageHeading.styled';
import Title from './components/Title';
import Byline from './components/Byline';

export type PageHeadingProps = {
    title?: string;
    byline?: string;
    icon?: JSX.Element;
    cta?: JSX.Element;
    isLoading?: boolean;
};

const PageHeadingWrapper: React.FC = ({ children }) => {
    return (
        <Styled.ResponsiveWrapper minHeight={'48px'}>
            <Styled.ResponsiveBox mr={'sm'}>{children}</Styled.ResponsiveBox>
        </Styled.ResponsiveWrapper>
    );
};

const PageHeadingWrapperWithCta: React.FC = ({ children }) => {
    return (
        <Styled.ResponsiveWrapper maxWidth={'100%'}>
            <Styled.ResponsiveBox
                mr={'sm'}
                display="flex"
                justifyContent={'space-between'}
            >
                {children}
            </Styled.ResponsiveBox>
        </Styled.ResponsiveWrapper>
    );
};

const PageHeading: React.FC<PageHeadingProps> = ({
    title = '',
    byline,
    icon,
    cta,
    isLoading = false,
}) => {
    const isMobile = useBreakpoint('md');

    return cta ? (
        <PageHeadingWrapperWithCta>
            <Title isLoading={isLoading} title={title} icon={icon} />
            <Byline isLoading={isLoading} byline={byline} />
            <Box
                display="flex"
                alignItems={'flex-end'}
                mb={isMobile ? '0px' : '10px'}
                p={0}
                m={0}
            >
                {cta}
            </Box>
        </PageHeadingWrapperWithCta>
    ) : (
        <PageHeadingWrapper>
            <Title isLoading={isLoading} title={title} icon={icon} />
            <Byline isLoading={isLoading} byline={byline} />
        </PageHeadingWrapper>
    );
};

export default PageHeading;
